<script setup lang="ts">
import type { DataStateStatus } from "@pinia/colada";

defineProps<{ isLoading: boolean; status: DataStateStatus; error: Error | null }>();
</script>

<template>
  <UiLoading v-if="isLoading || status === 'pending'" />
  <div v-else-if="status === 'error'" class="prose text-danger">
    <p>{{ error?.message || "Une erreur est survenue." }}</p>
  </div>
  <slot v-else />
</template>
